var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"center"}},[_c('v-dialog',{attrs:{"persistent":"","width":"85%"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('h3',[_vm._v(_vm._s(_vm.title))])]),_c('v-spacer'),_c('v-card-text',[_c('v-container',[_vm._t("modal-content")],2)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }